import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loading': false,
  'loadingParametersByProvider': false,
  'parameters': {},
  'parametersByProvider': {},
};

export const iccmatrix = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_ICC_PARAMETERS]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_ICC_PARAMETERS]: (state, action) => ({
      ...state,
      'parameters': action.response.data,
      'loading': false,
    }),
    [ActionTypes.FETCHED_ICC_PARAMETERS_FAILED]: (state, action) => ({
      ...state,
      'parameters': {},
      'loading': false,
    }),
    [ActionTypes.FETCHING_ICC_PARAMETERS_BY_PROVIDER]: (state, action) => ({
      ...state,
      'loadingParametersByProvider': true,
    }),
    [ActionTypes.FETCHED_ICC_PARAMETERS_BY_PROVIDER]: (state, action) => ({
      ...state,
      'loadingParametersByProvider': false,
      'parametersByProvider': action.response.data,
    }),
    [ActionTypes.FETCHED_ICC_PARAMETERS_BY_PROVIDER_FAILED]: (state, action) => ({
      ...state,
      'loadingParametersByProvider': false,
      'parametersByProvider': {},
    }),
    [ActionTypes.CLEAR_ICC_PARAMETERS_BY_PROVIDER]: (state, action) => ({
      ...state,
      'parametersByProvider': {},
    }),
  })(state, action);
};

export const iccCategoriesParametersForm = (state, action) => {
  return createReducer({}, {
    [ActionTypes.FETCHED_ICC_PARAMETERS]: (state, action) => ({
      ...state,
      'values': {
        ...state.values,
        ...action.response.data.categories,
        
      },
    }),
  })(state, action);
};

export const iccMadParametersForm = (state, action) => {
  return createReducer({}, {
    [ActionTypes.FETCHED_ICC_PARAMETERS]: (state, action) => ({
      ...state,
      'values': {
        ...state.values,
        ...action.response.data.mad,
      },
    }),
  })(state, action);
};
